import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class TemrTimelineService {
  temrTimeline: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'temr_timeline/list/?';
  private AddRecord = webapi + 'temr_timeline/create';
  private EditRecord = webapi + 'temr_timeline/update';
  private GetRecord = webapi + 'temr_timeline/byid/';
  private DeleteRecord = webapi + 'temr_timeline/delete/';
  private UpdateBoolean = webapi + 'temr_timeline/updateboolean/';
  private SaveEmr = webapi + 'temr_timeline/saveemr';
  private GetTimelineByVisitId = webapi + 'temr_timeline/byvisitid/';
  private UpdateDoctorAdvice = webapi + 'temr_timeline/updatedoctoradvice?';
  private UpdateSpecialInstruction= webapi + 'temr_timeline/updateSplcInst?';
  private CreateEposide = webapi + 'temr_timeline/createeposide/'; //  create Eposide
  private CreateEmgEposide= webapi + 'temr_timeline/createemgeposide/'; //  create Eposide
  private GetTimelineByAdmissionIdAndDate = webapi + 'temr_timeline/getTimelineByAdmissionIdAndDate';
  private setSysExam = webapi + 'temr_timeline/updateSysExam/';

  constructor(private http: Http) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    // console.log(qString);
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editBooleanRecordService(timelineId: any, key: any, booleanValue: any) {
    return this.http.put(this.UpdateBoolean + timelineId + '/' + key + '/' + booleanValue, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  saveEMRService(timelineId: any, staffId: any) {
    return this.http.put(this.SaveEmr + '/' + timelineId + '/' + staffId
      , {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordByVisitIdService(id: any) {
    return this.http.get(this.GetTimelineByVisitId + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  createEposide(admissionPatientID: any, visitRegistrationSource: any, selectedStaff: any, serviceid: any, admissionid: any) {
    return this.http.get(this.CreateEposide + admissionPatientID + '/' + visitRegistrationSource + '/' + selectedStaff + '/' + serviceid + '/' + admissionid)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

    createEmgEposide(admissionPatientID: any, visitRegistrationSource: any, selectedStaff: any, serviceid: any, visitId: any) {
    return this.http.get(this.CreateEmgEposide + admissionPatientID + '/' + visitRegistrationSource + '/' + selectedStaff + '/' + serviceid + '/' + visitId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  // addDoctorAdvice(timelineId: any, selectedFollowUpDate: any, visitDoctorAdvice: any, appoinmentId: any) {
  //   return this.http.get(this.UpdateDoctorAdvice + timelineId + '/' + selectedFollowUpDate + '/' + visitDoctorAdvice+ '/'+appoinmentId)
  //     .toPromise()
  //     .then(response => response.json())
  //     .catch(this.handleError);
  // }

  getTimelineByAdmissionIdAndDate(model: any) {
    return this.http.post(this.GetTimelineByAdmissionIdAndDate, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

    setSysExamBytimelineId(timelineId: any,sysExam: any ) {
        return this.http.post(this.setSysExam + "?timelineId="+timelineId+"&sysExam="+sysExam,'', {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }


    addDoctorAdvice(timelineId: any, visitFollowDate: any, visitDoctorAdvice: any, appoinmentId: any) {
        return this.http.get(this.UpdateDoctorAdvice + 'timelineId='+ timelineId + '&visitFollowDate=' + visitFollowDate + '&visitDoctorAdvice=' + visitDoctorAdvice+ '&appoinmentId='+appoinmentId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addSpecialInstruction(timelineId: any, selectedFollowUpDate: any, visitDoctorAdvice: any, appoinmentId: any) {
        return this.http.get(this.UpdateSpecialInstruction + 'timelineId='+ timelineId + '&selectedFollowUpDate=' + selectedFollowUpDate + '&inst=' + visitDoctorAdvice+ '&appoinmentId='+appoinmentId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/temr-timeline/temr-timeline.service.ts